if (!customElements.get('truncate-text')) {
  customElements.define('truncate-text', class TruncateText extends HTMLElement {
    constructor() {
      super();
      if(!this.dataset.ignore) {
        this.button = this.querySelector('.button--truncate-text-js');
        this.contentWrapper = this.querySelector('.truncate-text__content-wrapper');
        this.content = this.querySelector('.truncate-text__content');
        this.expanded = false;
      }
    }

    connectedCallback() {
      if(this.button) {
        this.onClickButtonHandler = this.onClickButton.bind(this);
        this.button.addEventListener('click', this.onClickButtonHandler);
        this.onResizeHandler = this.onResize.bind(this);
        window.addEventListener('resize', this.onResizeHandler);
        this.snapToWholeLine();
        this.calculateHeight();
      }
    }

    disconnectedCallback() {
      if(this.button) {
        this.button.removeEventListener('click', this.onClickButtonHandler);
        window.removeEventListener('resize', this.onResizeHandler);
      }
    }

    snapToWholeLine() {
      const lineHeight = parseFloat(getComputedStyle(this.content).lineHeight);
      if (!lineHeight || isNaN(lineHeight)) return;
      const raw = parseFloat(getComputedStyle(this).getPropertyValue('--truncate-text-length'));
      if (!raw || isNaN(raw)) return;
      const lines = Math.floor(raw / lineHeight);
      const snapped = lines * lineHeight;
      this.style.setProperty('--truncate-text-length', snapped + 'px');
      this.snappedHeight = snapped;
    }

    onClickButton() {
      if (this.expanded) {
        this.collapse();
      } else {
        this.expand();
      }
    }

    expand() {
      this.expanded = true;
      this.button.classList.add('expanded');
      Motion.animate(this.contentWrapper, { maxHeight: `${this.content.clientHeight}px` }, { duration: 0.5, easing: `cubic-bezier(.03,.93,.97,1)` }).finished.then(() => {
        this.contentWrapper.classList.add('expand');
        this.contentWrapper.removeAttribute('style');
      });
    }

    collapse() {
      this.expanded = false;
      this.button.classList.remove('expanded');
      this.contentWrapper.classList.remove('expand');
      this.contentWrapper.style.maxHeight = `${this.content.clientHeight}px`;
      // Force reflow
      this.contentWrapper.offsetHeight;
      const target = this.snappedHeight ? `${this.snappedHeight}px` : getComputedStyle(this).getPropertyValue('--truncate-text-length');
      Motion.animate(this.contentWrapper, { maxHeight: target }, { duration: 0.5, easing: `cubic-bezier(.03,.93,.97,1)` });
    }

    onResize() {
      this.snapToWholeLine();
      this.calculateHeight();
    }

    calculateHeight() {
      if(this.contentWrapper.clientHeight < this.content.clientHeight) {
        this.button.closest('.truncate-text__button-wrapper').classList.remove('hidden');
      }
    }
  });
}
